/* Mr Bargain redesign: grade badges on theme cards, clean titles, product-row arrows, today's hours, cart drawer note */
(function () {
  function grade(t) {
    t = ' ' + (t || '').toLowerCase();
    if (/[-(]\s*as new\b/.test(t)) return ['As New', 'as-new'];
    if (/[-(]\s*excellent\b/.test(t)) return ['Excellent', 'excellent'];
    if (/[-(]\s*good\b/.test(t)) return ['Good', 'good'];
    return ['Brand New', 'new'];
  }
  function clean(t) {
    return (t || '').replace(/\s[-–]\s(As New|Excellent|Good|Refurbished)\b/gi, '').replace(/\s[-–]\sNew$/i, '').trim();
  }
  function cards() {
    var list = document.querySelectorAll('.yv-product-card:not([data-mb-grade])');
    for (var i = 0; i < list.length; i++) {
      var c = list[i];
      var ti = c.querySelector('.yv-product-title');
      var bp = c.querySelector('.badges-parent');
      if (!ti || !bp) continue;
      c.setAttribute('data-mb-grade', '1');
      var full = ti.getAttribute('title') || ti.textContent;
      if (!bp.querySelector('.mb-grade')) {
        var g = grade(full);
        var s = document.createElement('span');
        s.className = 'mb-grade mb-grade--' + g[1];
        s.textContent = g[0];
        bp.insertBefore(s, bp.firstChild);
      }
      var cl = clean(ti.textContent);
      if (cl && cl !== ti.textContent.trim()) ti.textContent = cl;
    }
  }
  function drawer() {
    var list = document.querySelectorAll('.yv-cart-drawer .cart-listed-new-display');
    for (var i = 0; i < list.length; i++) {
      var el = list[i];
      if (el.querySelector('.mb-shop-info')) continue;
      var d = document.createElement('div');
      d.className = 'mb-shop-info mb-shop-info--drawer';
      d.innerHTML =
        '<p class="mb-ship-line"><strong>Standard</strong> 3–5 business days · <strong>Express</strong> 2–4 business days</p>' +
        '<p class="mb-disclaimer">Online prices may differ from in-store prices.</p>';
      el.appendChild(d);
    }
  }
  function today() {
    var day;
    try { day = new Date().toLocaleDateString('en-AU', { timeZone: 'Australia/Perth', weekday: 'short' }).slice(0, 3); } catch (e) { return; }
    var rows = document.querySelectorAll('.mb-hours tr[data-day="' + day + '"]:not(.is-today)');
    for (var i = 0; i < rows.length; i++) rows[i].classList.add('is-today');
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-mb-rail-prev],[data-mb-rail-next]');
    if (!b) return;
    var sec = b.closest('.mb-rail');
    var tr = sec && sec.querySelector('[data-mb-rail]');
    if (!tr) return;
    var dir = b.hasAttribute('data-mb-rail-prev') ? -1 : 1;
    tr.scrollBy({ left: dir * tr.clientWidth * 0.9, behavior: 'smooth' });
  });
  var queued = false;
  function run() {
    queued = false;
    try { cards(); drawer(); today(); } catch (e) {}
  }
  function queue() {
    if (queued) return;
    queued = true;
    (window.requestAnimationFrame || setTimeout)(run);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  if ('MutationObserver' in window) {
    new MutationObserver(queue).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
